<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> create </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            {{defineIDGShortLastSix(this.maintActivity.basic.idi)}} FM
            <v-spacer/>
            {{displayDocumentIDGTypeA(this.maintActivity.basic.tag, this.maintActivity.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2">
                  Maintenance Activity
                </div>
                <v-spacer/>
                <v-chip :color="ui.chipColor" :class="ui.textSubheading">
                  <v-icon left :color="ui.btnColor">work_history</v-icon>
                  {{this.maintActivity.stats.nm5}}
                </v-chip>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm8>
                  <v-text-field
                  v-model="localForm.title"
                  label="part name"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="title"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.type"
                  :items="activityTypeOptions"
                  label="type"
                  prepend-icon="grid_view"
                  hint="part type"
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.id"
                  label="part id"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="fingerprint"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.discipline"
                  :items="engineeringDiscipline"
                  label="discipline"
                  prepend-icon="engineering"
                  hint="discipline"
                  required
                  >
                </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.owner"
                  :items="activityOwnerOptions"
                  prepend-icon="person"
                  hint="owner"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.driver"
                  :items="activityDriverOptions"
                  prepend-icon="admin_panel_settings"
                  hint="driver"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.comp"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="assured_workload"
                  hint="compliance"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.scope"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="check_box_outline_blank"
                  hint="scope"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="localForm.failure"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="error_outline"
                  hint="failure modes"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.method"
                  :items="activityMethodOptions"
                  prepend-icon="adjust"
                  hint="method"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.model"
                  :items="activityModelOptions"
                  hint="model"
                  prepend-icon="model_training"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm3>
                  <v-text-field
                  v-model="localForm.frequency"
                  :rules="ruleNumberMoreThanZero"
                  prepend-icon="manage_history"
                  persistent-hint
                  hint="freq"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                  v-model="localForm.unit"
                  :items="activityFrequencyOptions"
                  prepend-icon="event"
                  persistent-hint
                  hint="unit"
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                  v-model="localForm.condition"
                  :items="activityConditionOptions"
                  prepend-icon="build_circle"
                  hint="condition"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-select
                  v-model="localForm.imp"
                  :items="activityResourceImpactOptions"
                  prepend-icon="group_add"
                  hint="impact"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.coste"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="paid"
                  hint="cost"
                  :prefix="localForm.costu"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="localForm.carbe"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="co2"
                  suffix="kg"
                  :hint="localForm.carbu"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <InfoDateAgoName :data="this.maintActivity.stats"/>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localForm.com"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="ruleMustBeNotUndefinedANDLessThan1000"
                  hint="maintActivity description"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-xs-only">
              <v-icon left> exit_to_app </v-icon>
                Close
            </v-btn>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> exit_to_app </v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn @click="deleteMaintActivity()" color="error" flat
              class="hidden-xs-only"
              v-if="this.localForm.status !== 'Order'"
              :disabled="this.getMaintActivityList.length < 1">
              <v-icon left> delete </v-icon>
                Delete
            </v-btn>
            <v-btn @click="deleteMaintActivity()" color="error" flat
              class="hidden-sm-and-up"
              v-if="this.localForm.status !== 'Order'"
              :disabled="this.getMaintActivityList.length < 1">
              <v-icon> delete </v-icon>
            </v-btn>
            <v-btn @click="validate()" :color="ui.btnColor" flat
             class="hidden-xs-only">
              <v-icon left> create </v-icon>
                Update
            </v-btn>
            <v-btn @click="validate()" :color="ui.btnColor" flat
            class="hidden-sm-and-up">
              <v-icon> create </v-icon>
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import master from "@/data/forms/mixins/master.js";
import activityOptions from "@/data/options/mixins/activityOptions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import InfoDateAgoName from "@/frame/display/components/InfoDateAgoName";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    master,
    activityOptions,
    techOptions,
    rulesTextfield,
    dateFunctions,
    listFunctions,
    uisettings,
    docRevsModFunctions,
    numberFunctions,
    financeFunctions,
    apptheme,
    displayFunctions
  ],
  components: {
    InfoDateAgoName
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getMaintActivityList", "getUser", "getMaintActivityListCounter"]),
    reactiveMaintActivityList() {
      return this.getMaintActivityList;
    }
  },
  props: {
    maintActivity: {
      type: Object
    }
  },
  data() {
    return {
      hideActions: true,
      dialog: false,
      valid: false,
      enableSpinner: false,
      localForm: {
        id: "", // parts Id
        title: "", // parts title
        discipline: "", // eng. discipline
        com: "", // parts comments
        driver: "", // parts
        comp: "", // hell
        scope: "",
        failure: "",
        method: "", // pattern
        model: "", // type
        frequency: "",
        unit: "",
        condition: "",
        imp: "",
        coste: "",
        costu: "",
        carbe: "",
        carbu: ""
      }
    };
  },
  beforeMount() {
    this.localForm.title = this.maintActivity.basic.title;
    this.localForm.id = this.maintActivity.basic.id;
    this.localForm.com = this.maintActivity.char.com;
    this.localForm.condition = this.maintActivity.char.cond;
    this.localForm.driver = this.maintActivity.char.driver;
    this.localForm.discipline = this.maintActivity.char.dis;
    this.localForm.type = this.maintActivity.char.type;
    this.localForm.model = this.maintActivity.char.model;
    this.localForm.method = this.maintActivity.char.method;
    this.localForm.scope = this.maintActivity.char.scope;
    this.localForm.failure = this.maintActivity.char.fail;
    this.localForm.frequency = this.maintActivity.char.freq;
    this.localForm.unit = this.maintActivity.char.unit;
    this.localForm.coste = this.maintActivity.char.coste;
    this.localForm.comp = this.maintActivity.char.comp;
    this.localForm.carbe = this.maintActivity.char.carbe;
    this.localForm.status = this.maintActivity.char.status;
    this.localForm.owner = this.maintActivity.char.owner;
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    refreshList() {
      let store = "changeMaintActivityListCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getMaintActivityListCounter + 1);
      this.$store.dispatch(store, this.getMaintActivityListCounter - 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(5.12, 1); // maintActivity removed.
    },
    deleteMaintActivity() {
      // LIST UPDATE
      let tempList = this.getMaintActivityList;
      let newList = this.deleteItemReturnList(this.maintActivity, tempList);
      this.$store.dispatch("changeMaintActivityList", newList);
      this.refreshList();
      this.dialog = false;
    },
    validate() {
      // cosole.log(this.taskForm)
      if (this.$refs.form.validate() === true) {
        // hi
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // add dates
        let tempForm = this.maintActivity;
        // BASIC
        tempForm.basic.title = this.localForm.title;
        tempForm.basic.id = this.localForm.id;

        // CHAR
        tempForm.char.type = this.localForm.type;
        tempForm.char.dis = this.localForm.discipline;
        tempForm.char.driver = this.localForm.driver;
        tempForm.char.model = this.localForm.model;
        tempForm.char.method = this.localForm.method;
        tempForm.char.freq = this.localForm.frequency;
        tempForm.char.unit = this.localForm.unit;
        tempForm.char.cond = this.localForm.condition;
        tempForm.char.com = this.localForm.com;
        tempForm.char.comp = this.localForm.comp;
        tempForm.char.scope = this.localForm.scope;
        tempForm.char.fail = this.localForm.failure;
        tempForm.char.cond = this.localForm.condition;
        tempForm.char.imp = this.localForm.imp;
        tempForm.char.coste = this.localForm.coste;
        tempForm.char.carbe = this.localForm.carbe;
        tempForm.char.owner = this.localForm.owner;
        tempForm.char.status = "Created";

        // STATS
        tempForm.stats.date = moment().format();
        tempForm.stats.dcrt = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var tempList = this.getMaintActivityList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.changeItemReturnList(parseobj, tempList);
        this.$store.dispatch("changeMaintActivityList", newList);
        this.refreshList();
        this.dialog = false;
      }
    }
  }
};
</script>
